import React from 'react';

import {
  PhotoItemValue,
  VideoItemValue,
  AudioItemValue,
} from '@fulcrumapp/fulcrum-core';
import MediaViewer from './media-viewer';
import { useApp } from '../../hooks/use-app';
import displayableItemForItem from './display/displayable-item-for-item';

export default function mediaShare() {
  const app = useApp();

  const {
    type, media_id, media, track,
  } = app.params;

  let item = null;

  if (type === 'video') {
    // @ts-ignore
    item = new VideoItemValue(null, { video_id: media_id });
  } else if (type === 'photo') {
    // @ts-ignore
    item = new PhotoItemValue(null, { photo_id: media_id });
  } else if (type === 'audio') {
    // @ts-ignore
    item = new AudioItemValue(null, { audio_id: media_id });
  }

  // Don't render MediaViewer if there's no valid item
  if (!item) {
    return null;
  }

  const displayableItem = displayableItemForItem(item, app.dataSource);

  const mediaProps = {
    record: null,
    feature: undefined,
    mapVisible: true,
    initialItem: displayableItem,
    visible: true,
    metadata: media,
    track,
    mediaValueItems: [displayableItem],
  };

  return (
    <MediaViewer {...mediaProps} />
  );
};
